import axios from 'axios';
export default axios.create({
    baseURL: 'https://hml-api.bancodafelicidade.com.br'
})

//'http://54.175.100.84:3333'

//'https://hml-api.bancodafelicidade.com.br'